<template>
    <div>
        <LoadingScreen v-if="isLoadingScreen" />
        <div class="sport" v-else>
            <div class="sport__header">
                <div class="sport_home" @click="onBackToHome">
                    <span class="chevron"></span>
                    <span class="sport_text">{{ getTranslatedText('home') }}</span>
                </div>
                <span class="sport_text sports">{{ getTranslatedText('lucky numbers') }}</span>
            </div>
            <div class="sport__iframe">
                <iframe :src="iframeUrl"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
import LoadingScreen from '@/components/common/loading/loading.vue'
import languageMixins from '@/mixins/language-mixins'
import utilsMixin from '@/mixins/function-utils'
import printMixins from '@/mixins/print-mixins'

export default {
    mixins: [languageMixins, utilsMixin, printMixins],
    components: { LoadingScreen },
    data() {
        return {
            isLoadingScreen: false,
            iframeUrl: '',
        }
    },
    mounted() {
        this.renderIframe()
        window.addEventListener('message', this.handleIframeMessage)
    },
    unmounted() {
        window.removeEventListener('message', this.handleIframeMessage)
    },
    methods: {
        handleIframeMessage(event) {
            if (event.data.type === 'numbers-betslip' && event.data.action === 'print') {
                this.printNumber(event.data.data)
            }
        },

        renderIframe() {
            const setting = this.$store.state.configDevice
            const setup = this.$store.state.config.setup
            const token = this.$store.state.token
            const lang = this.$store.state.lang
            if (setup.isTestingBrowers && this.isObjEmpty(setting)) {
                this.iframeUrl = `${setup.apiUrl}/retail/number-for-pos/index?locale=${lang}&admin_jwt=${token}&t=${Date.now()}&app_version=browser.1&toggleTournaments=false`
            } else {
                if (!this.isObjEmpty(setting)) {
                    this.iframeUrl = `${setup.apiUrl}/retail/number-for-pos/index?locale=${lang}&admin_jwt=${token}&t=${Date.now()}&device_network_mac_address=${setting.mac}&app_version=${setting.appVersion}&device_serial_number=${setting.serial}&device_unique_id=${setting.uniqueId}&toggleTournaments=false`
                }
            }
        },

        onBackToHome() {
            const query = this.$route.query
            this.$router.push({ path: '/', query })
        },
    },
}
</script>

<style lang="scss">
@import '@/public/scss/sports/sports.scss';
</style>
